var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-tooltip',{attrs:{"content":_vm.tip,"placement":"top"}},[_c('i',{staticClass:"el-icon-question"})]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }